module.exports = __webpack_public_path__ + "static/media/capa-pdf-en.1c2a10f5.png";